import templateUrl from 'emun.salesrep/salesrep-top-underperformers.htm';
import salesrepConfig from 'emun.salesrep/salesrep.config'
import ServiceBus from 'servicestack/service-bus'

class SalesRepTopUnderperformerssController {
	constructor($window, $rootScope, retailerPrompt, createAutoQuery, utils) {
		let $ctrl = this;
		var context = $ctrl.context || 'rep';
		$ctrl.bus = new ServiceBus();
		$ctrl.config = salesrepConfig;

		var queryCriteria = "";
		var filter = "RepId";
		if (context === 'executive') {
			filter = '';
		} else if (context === 'vendor') {
			filter = 'VendorId' + '=' + $ctrl.rep.id;
		} else if (context === 'subrep') {
			filter = 'SubRepId' + '=' + $ctrl.rep.id;
		} else if (context === 'manager') {
			filter = 'ManagerId' + '=' + $ctrl.rep.id;
		} else {
			filter = filter + '=' + $ctrl.rep.id
		}
		if ($ctrl.insideSales === 'true') {
			queryCriteria = '&IsInsideSales=true';
		}

		if ($ctrl.repGroup && $ctrl.repGroup !== 'ALL') {
			$ctrl.repGroupFilter = '?RepGroupName=' + $ctrl.repGroup;
			queryCriteria = queryCriteria + '&RepGroupName=' + $ctrl.repGroup;
		}
		$ctrl.utils = utils;
		$ctrl.underperformers = [];
		$ctrl.ytdQuery = createAutoQuery({
			//url: 'QueryOrderTotals.json?dateRange=YTD&grouping=strCustomerID&groupingLabel=strCompanyName&' + filter + '=' + $ctrl.rep.id,
			url: 'QuerySalesDailyCustomerTotals.json?Fields=CustomerName,SalesRepName&Sum=OrderTotal,OrderCount&dateRange=YTD&GroupBy=CustomerID,CustomerName,SalesRepName&' + filter + queryCriteria,
			autoLoad: true,
			pageSize: 10000,
			onLoaded: function (ytdResults) {
				$ctrl.lytdQuery = createAutoQuery({
					//                    url: 'QueryOrderTotals.json?dateRange=LYTD&grouping=strCustomerID&groupingLabel=strCompanyName&' + filter + '=' + $ctrl.rep.id,
					url: 'QuerySalesDailyCustomerTotals.json?Fields=CustomerName,SalesRepName,strRanking&Sum=OrderTotal,OrderCount&dateRange=LYTD&GroupBy=CustomerID,CustomerName,SalesRepName,strRanking&' + filter + queryCriteria,
					autoLoad: true,
					pageSize: 10000,
					onLoaded: function (lytdResults) {
						lytdResults.results.forEach(function (lytd) {
							var obj = {};
							obj.label = lytd.customerName;
							obj.salesRepName = lytd.salesRepName;
							obj.id = lytd.customerID;
							obj.lytdSales = lytd.sumOrderTotal;
							obj.ranking = lytd.strRanking;
							var ytd = ytdResults.results.filter(function (obj) {
								return obj.customerID === lytd.customerID;
							});
							if (ytd.length > 0) {
								obj.ytdSales = ytd[0].sumOrderTotal;
							} else {
								obj.ytdSales = 0;
							}
							obj.diff = obj.ytdSales - obj.lytdSales;
							var percent = Math.round((obj.ytdSales / obj.lytdSales) * 100);
							if (percent < 100) {
								obj.percent = 100 - percent;
								obj.trend = 'down';
							} else if (percent > 100) {
								obj.percent = percent - 100;
								obj.trend = 'up';
							} else {
								obj.percent = 100;
								obj.trend = 'neutral';
							}
							$ctrl.underperformers.push(obj);
						});
						$ctrl.sortedUnderperformers = _.sortBy($ctrl.underperformers, 'diff').slice(0, salesrepConfig.topUnderPerformersSlice);
						$ctrl.sortedUnderperformersALL = _.sortBy($ctrl.underperformers, 'diff').slice(0, 100);
					}
				});
			}
		});
	}

	downloadData() {
		let $ctrl = this;
		var itemsFormatted = [];

		var headers = {
			name: 'Name',
			id: "Id",
			SalesRep: 'SalesRep',
			LYTD: "LYTD",
			YTD: "YTD",
			Diff: "Diff"
		};

		// format the data
		$ctrl.sortedUnderperformersALL.forEach((item) => {
			itemsFormatted.push({
				name: item.label.replace(/,/g, ''), // remove commas to avoid errors,
				id: item.id,
				SalesRep: item.salesRepName.replace(/,/g,''),
				LYTD: item.lytdSales,
				YTD: item.ytdSales,
				Diff: item.diff
			});
		});

		var fileTitle = 'top-underperforming-accounts';
		$ctrl.utils.exportCSVFile(headers, itemsFormatted, fileTitle);
	}
}

let SalesRepTopUnderperformers = {
	bindings: {
		rep: '<',
		repGroup: '@',
		context: '@',
		insideSales: '@'
	},
	controller: SalesRepTopUnderperformerssController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
};


export default SalesRepTopUnderperformers;